export default {
  'en-US': {
    channels: {
      Amazon: 'Amazon',
      API: 'API',
      BackerKit: 'BackerKit',
      BigCommerce: 'BigCommerce',
      CrateJoy: 'CrateJoy',
      Ebay: 'Ebay',
      Excel: 'Excel',
      Exchange: 'Exchange',
      ExternalInventoryTransfer: 'External Inventory Transfer',
      InternalInventoryTransfer: 'Internal Inventory Transfer',
      Magento: 'Magento',
      ManualOrder: 'Manual Order',
      PrepaidFreight: 'Prepaid Freight',
      PrepaidStandardCarrier: 'Prepaid Standard Carrier',
      Return: 'Return',
      ShipStation: 'ShipStation',
      Shopify: 'Shopify',
      SquareSpace: 'SquareSpace',
      StitchLabs: 'StitchLabs',
      TicTail: 'TicTail',
      Walmart: 'Walmart',
      WarehouseReceiving: 'Warehouse Receiving',
      WooCommerce: 'WooCommerce',
      WooCommerceV2: 'WooCommerceV2',
      Zapier: 'Zapier',
      ManualB2B: 'Manual B2B',
      ClientWarehouseOrder: 'Manual',
      ExchangeOrder: 'Exchange',
      SpsCommerce: 'SPS Commerce',
      Kitting: 'Kitting',
      TikTok: 'TikTok',
      Transportation: 'Transportation'
    }
  },
  'ja-JP': {
    channels: {
      Amazon: 'Amazon',
      API: 'API',
      BackerKit: 'BackerKit',
      BigCommerce: 'BigCommerce',
      CrateJoy: 'CrateJoy',
      Ebay: 'Ebay',
      Excel: 'Excel',
      Exchange: 'Exchange',
      ExternalInventoryTransfer: '外部在庫転送',
      InternalInventoryTransfer: '内部在庫転送',
      Magento: 'Magento',
      ManualOrder: 'マニュアルオーダー',
      PrepaidFreight: 'プリペイド貨物',
      PrepaidStandardCarrier: 'プリペイドスタンダードキャリア',
      Return: '戻る',
      ShipStation: 'ShipStation',
      Shopify: 'Shopify',
      SquareSpace: 'SquareSpace',
      StitchLabs: 'StitchLabs',
      TicTail: 'TicTail',
      Walmart: 'Walmart',
      WarehouseReceiving: '倉庫受信',
      WooCommerce: 'WooCommerce',
      WooCommerceV2: 'WooCommerceV2',
      Zapier: 'Zapier',
      ManualB2B: 'マニュアルB2B',
      TikTok: 'TikTok',
      Transportation: 'Transportation'
    }
  }
}

